import { Currencies } from '../../../helpers/currency/getCurrencySymbol'

export default function getHistory(obj: any, prec: any) {
  const { user_name, bet_info, winCoef, round_id } = obj
  const { bet_id, bet, currency, win } = bet_info

  const content = [
    {
      name: 'bet id',
      content: bet_id !== '' ? '#' + bet_id : '-',
    },
    {
      name: 'user',
      content: user_name !== '' ? user_name : '-',
    },
    {
      name: 'payout',
      content: winCoef !== 0 ? winCoef + 'x' : '0.00x',
    },
    {
      name: 'bet amount',
      content:
        bet !== 0
          ? Currencies[currency] &&
            Currencies[currency].symbol + (+bet).toFixed(prec)
          : '-',
    },
    {
      name: 'win amount',
      content:
        Number(win) > 0
          ? Currencies[currency] && Currencies[currency].symbol + win.toString()
          : '0.00',
    },
  ]

  return { content, win, round_id }
}
